import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormFieldComponent } from '@shared/models/classes/FormFieldComponent';
import { PmAsteriskComponent } from '../pm-form-field/pm-asterisk/pm-asterisk.component';

@Component({
  standalone: true,
  selector: 'pm-form-field-label',
  imports: [CommonModule, PmAsteriskComponent],
  templateUrl: './pm-form-field-label.component.html',
  styleUrl: './pm-form-field-label.component.scss',
})
export class PmFormFieldLabelComponent extends FormFieldComponent {
  displayValue(index: number) {
    if (this.ctrl.value === null) return null;
    if (typeof this.ctrl?.value === 'object') {
      return Object.values(this.ctrl.value)?.[index];
    }
    return null;
  }
}
